import { render, staticRenderFns } from "./PFIOnboardingForm.vue?vue&type=template&id=7ccad56e&scoped=true&"
import script from "./PFIOnboardingForm.vue?vue&type=script&lang=js&"
export * from "./PFIOnboardingForm.vue?vue&type=script&lang=js&"
import style0 from "./PFIOnboardingForm.vue?vue&type=style&index=0&id=7ccad56e&lang=scss&scoped=true&"
import style1 from "./PFIOnboardingForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccad56e",
  null
  
)

export default component.exports